import axios, { AxiosRequestConfig } from "axios";
const qs = require("qs");
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: { "content-type": "application/x-www-form-urlencoded" }
});

service.interceptors.request.use(
  config => {
    if (config.method === "post") {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(response => {
  const res = response.data;
  if (Number(res.code) === 200) {
    return Promise.resolve(res.data);
  } else {
    return Promise.reject(res.message);
  }
});
export default function request(config: AxiosRequestConfig): any {
  return service(config);
}
